import type { TimelineOutputSuperResolution } from '../types/timeline'

function asStrictBool(v: unknown): boolean | undefined {
  if (v === true || v === false) return v
  return undefined
}

/**
 * 从创作任务 result.metadata 解析输出侧超清状态（与后端 CreationService 写入字段对齐）。
 */
export function parseOutputSuperResolutionFromCreationMetadata(
  metadata: Record<string, unknown> | undefined | null,
): TimelineOutputSuperResolution | undefined {
  if (!metadata || typeof metadata !== 'object') return undefined

  const attempted =
    metadata.outputSuperResolutionAttempted === true ||
    metadata.outputSuperResolution === true

  const rawPer = metadata.outputSuperResolutionPerImage
  let perImageSuccess: boolean[] | undefined
  if (Array.isArray(rawPer) && rawPer.length > 0) {
    const mapped = rawPer.map((x) => asStrictBool(x))
    if (mapped.every((x) => x !== undefined)) {
      perImageSuccess = mapped as boolean[]
    }
  }

  if (!attempted && !perImageSuccess?.length) return undefined

  return {
    attempted: attempted || Boolean(perImageSuccess?.length),
    ...(perImageSuccess?.length ? { perImageSuccess } : {}),
  }
}

/** 与时间线一轮实际展示的图片张数对齐（截取 metadata 中的 per-image 列表） */
export function sliceOutputSuperResolutionForImageCount(
  sr: TimelineOutputSuperResolution | undefined,
  imageCount: number,
): TimelineOutputSuperResolution | undefined {
  if (!sr?.attempted) return undefined
  if (!sr.perImageSuccess?.length) return sr
  return {
    attempted: true,
    perImageSuccess: sr.perImageSuccess.slice(0, imageCount),
  }
}
